import * as React from 'react';
import OEITable from './OEITable';
import { doNothing } from './OEIUtils';
import { fetchAllSalesforceMappingsData, saveAllSalesforceMappings, fetchAllSalesforceMappingsDataById, updateSalesforceMapping } from './APIService';
import { useEffect } from 'react';
import { EMPTY, END, LOADING, SALESFORCE, SYSTEM_NAME1 } from './Constants';
export default function SalesforcePage(props) {
    const [users, setUsers] = React.useState([])
    const [generate, setGenerate] = React.useState('true');
    const [closePopover, setClosePopover] = React.useState(true);
    const [message, setMessage] = React.useState(LOADING);
    const [errors, setErrors] = React.useState({ error1: EMPTY, error2: EMPTY, error3: EMPTY, error4: EMPTY });
    const [newSalesforceData, setNewSalesforceData] = React.useState({ checkedList: [] });

    useEffect(function () {
        fetchTableData();
    }, [])
    const fetchTableData = () => {
        fetchAllSalesforceMappingsData().then(response => {
            response.length === 0 ? setMessage('There are no Salesforce accounts mapped') : setMessage(EMPTY)
            setUsers(getfilteredResponse(response));
        })
    };
    const getValueByIndex = (value, index) => {
        var array = value.split("/");
        return array[index];
    }

    const getfilteredResponse = (array) => {
        var flags = [], filtered = [], l = array.length, i;
        for (i = 0; i < l; i++) {
            if (flags[array[i].subAccount]) continue;
            flags[array[i].subAccount] = true;
            filtered.push(array[i]);
        }
        var output = [], fillteredArrayLength = filtered.length, j;
        for (j = 0; j < fillteredArrayLength; j++) {
            var obj = filtered[j];
            var ob = array.filter(accountObj => accountObj.subAccount === obj.subAccount);
            var accNum = getAllcentralAccountNumbers(ob);
            const record = { id: filtered[j].subAccount, centalAccountNumbers: getString(accNum), centalAccountNames: getString(getAllcentralAccountNames(ob, { accNum })), numberOfMappings: accNum.length, subAccountName: filtered[j].subAccountName, systemIntgId: filtered[j].systemIntgId, subAccount: filtered[j].subAccount, salesforceAccountName: getValueByIndex(filtered[j].subAccountName, 0) }
            output.push(record);
        }
        return output;
    }
    const getAllcentralAccountNames = (array, numbers) => {
        var l = array.length, i, list = [], j, m = numbers.accNum.length;
        for (i = 0; i < m; i++) {
            for (j = 0; j < l; j++) {
                if (array[j].systemIntgId === numbers.accNum[i]) {
                    list.push(getValueByIndex(array[j].subAccountName, 1))
                    break;
                }
            }
        }
        return list
    }
    const getSalesforceDetails = (row) => {
        return fetchAllSalesforceMappingsDataById(row.id);
    }
    const getAllcentralAccountNumbers = (array) => {
        var l = array.length, list = [], i;
        for (i = 0; i < l; i++) list.push(array[i].systemIntgId)
        return [...new Set(list)];
    }
    const getString = (array) => {
        var all = EMPTY, i;
        for (var j = 0; j < array.length; j++)  all = all + (all.length > 0 ? ',' : EMPTY) + array[j]
        return all;
    }

    const removeMainItem = (item) => {
        let list = newSalesforceData.centralData;
        let removedData = newSalesforceData.removedData;
        let newCentralData = newSalesforceData.newCentralData;
        for (var i = 0; i < list.length; i += 1) {
          if (list[i]['oeCentralAccountName'] === item.oeCentralAccountName) {
            list.splice(i, 1);
            if (item.systemIdInfo !== undefined) { removedData.push(item) }
          }
        }
        for (var j = 0; j < newCentralData.length; j++) {
          if (newCentralData[j]['oeCentralAccountName'] === item.oeCentralAccountName) {
            newCentralData.splice(j, 1)
          }
        }
        setNewSalesforceData({ ...newSalesforceData, newCentralData: newCentralData, centralData: list, removedData: removedData });
      }

    const columns = [
        { id: 'salesforceAccountName', label: 'Salesforce Account Name', align: 'left', edit: false, width: '15%', button: false },
        { id: 'subAccount', label: 'Salesforce Account Number', button: false, edit: false, width: '15%' },
        { id: 'numberOfMappings', label: 'Number Of Mappings', button: false, edit: false, width: '15%' },
        { id: 'centalAccountNames', label: 'Central Account Names', button: false, edit: false, width: '15%' },
        { id: 'centalAccountNumbers', label: 'Central Account Numbers', button: false, edit: false, width: '15%' },
        { id: 'Edit', label: EMPTY, buttonLabel: 'Manage', button: true, edit: false, width: '10%', disable: true  }
    ];
    const getUsers = () => {
        const newArr = users.map((element, index) => {
            return { ...element, id: element.subAccount };
        });
        return newArr;
    }

    function validateData(data) {
        var errorList = [];
        if (data.salesforceAccountName === EMPTY) {
            errorList = { ...errorList, error2: "Salesforce Account Name is required" }
        } else if (data.salesforceAccountName.length > 255) {
            errorList = ({ ...errorList, error2: 'Salesforce Account Name length should be less than 255 characters' })
        } if (data.salesforceAccountNumber === EMPTY) {
            errorList = ({ ...errorList, error1: 'Salesforce Account Number is required' });
        } else if (data.salesforceAccountNumber.length > 255) {
            errorList = ({ ...errorList, error1: "Salesforce Account number length should be less than 255 characters" });
        } if (data.centralData.length < 1) {
            errorList = ({ ...errorList, error6: "At least one Central mapping is required" });
        }
        setErrors({ ...errorList })
        return errorList.length === 0;
    }


    function createSalesforceMapping(type) {
        if (type === END) {
            if (validateData(newSalesforceData)) {
                const list = getList(newSalesforceData.centralData, newSalesforceData.salesforceAccountNumber, newSalesforceData.salesforceAccountName);
                saveAllSalesforceMappings(list).then(response => {
                    setClosePopover(true);
                    fetchTableData();
                })
            }
        }

    }
    function getList(SalesforceDatalist, salesforceAccountNumber, salesforceAccountName) {
        let list = [];
        SalesforceDatalist && SalesforceDatalist.map(item => {
            item.checkedList.map(businessLine => {
                list.push({
                    clientName: SALESFORCE,
                    businessLine: businessLine,
                    subAccount: salesforceAccountNumber,
                    systemName: SYSTEM_NAME1,
                    subAccountName: `${salesforceAccountName}/${item.oeCentralAccountName}`,
                    salesforceAccountName: salesforceAccountName,
                    systemIntgId: item.oeCentralAccountNumber
                });
            });
        });
        return list;
    }
    const editSalesforceMapping = (row) => {
        let removedList = [], createList = [];
        if (validateData(newSalesforceData)) {
        if ((newSalesforceData.salesforceAccountNumber !== newSalesforceData.subAccount) || (newSalesforceData.salesforceAccountName !== newSalesforceData.name)) {
            removedList = getremoveList((newSalesforceData.centralData).concat(newSalesforceData.removedData));
            createList = newSalesforceData.centralData;
        } else {
            removedList = getremoveList(newSalesforceData.removedData)
            createList = newSalesforceData.newCentralData;
        }
        if ((newSalesforceData.salesforceAccountNumber !== newSalesforceData.subAccount) || (newSalesforceData.salesforceAccountName !== newSalesforceData.name)) {
            updateSalesforceMapping(removedList).then(response => {
                createSalesforceMappings(createList).then(res => {
                    close();
                })
            })
        } else  if (removedList !== [] && newSalesforceData.newCentralData !== [])
            updateSalesforceMapping(removedList).then(response => {
                createSalesforceMappings(createList).then(res => {
                    close();
                })
            })
        else if (removedList === [] && newSalesforceData.newCentralData !== []) {
            createSalesforceMappings(createList).then(res => {
                close();
            })
        } else if (removedList !== [] && newSalesforceData.newCentralData === []) {
            updateSalesforceMapping(removedList).then(response => {
                close();
            })
        }
        else  {
            close();
        }
    }}
    const createSalesforceMappings = (createList) => {
            const list = getList(createList, newSalesforceData.salesforceAccountNumber, newSalesforceData.salesforceAccountName)
            return saveAllSalesforceMappings(list).then(response => {
                close();
            });
    }
    function close() {
        setClosePopover(true);
        fetchTableData();
    }
    const getremoveList = (list) => {
        let getList = []
        list.map(i => {
            i.systemIdInfo &&
                i.systemIdInfo.map(item => getList.push(item))
        });
        return getList;
    }
    const deleteSalesforceMapping = (e) => {
      var  removedList = getremoveList((newSalesforceData.centralData).concat(newSalesforceData.removedData));
        updateSalesforceMapping(removedList).then(response => {
            close()
          })  
      }
    return (
        <>
            <OEITable removeMainItem={removeMainItem} getSalesforceDetails={getSalesforceDetails} delete={deleteSalesforceMapping} headerStyle='sticky-header' tableHeaderStyle='table-header' setSystemName={doNothing}
                edit={editSalesforceMapping} closePopover={closePopover} setClosePopover={setClosePopover} errors={errors} setErrors={setErrors}
                onclick={createSalesforceMapping} columns={columns} setGenerate={setGenerate} generate={generate}
                handleManageAcct={doNothing} tableHeadings='Salesforce / Central account mappings' setEmail={doNothing}
                setNewData={setNewSalesforceData} newAction='Mapping' handleClickGenerate={doNothing}
                newData={newSalesforceData} rowData={getUsers()} message={message} filterField={'salesforceAccountName'} ></OEITable>
        </>
    );
}
